/* =========================================================
   Tokyo Valentino — Quick View (self-contained)
   - One popup for every "Quick view" / "Choose options" button
   - Shared helpers for the cards: window.TVQuickView.getProduct (cached
     /products/<handle>.js) and the [data-tv-add] add-to-cart handler
   ========================================================= */
(function () {
  if (window.TVQuickView) return;

  /* small trust line under the buttons — edit as you like */
  var TRUST = [kgT('trust_packaging', 'Discreet, unmarked packaging'), kgT('trust_shipping', 'Free shipping over $59')];

  /* every button that should open the quick view */
  var TRIGGERS = '[data-tvrv-quick],[data-kgf-quick],[data-tv-quick],modal-opener [data-product-url]';


  var CSS = `
html.tvqv-lock, html.tvqv-lock body { overflow: hidden !important; }
.tvqv {
  --p: #ff2d8f; --v: #a855f7; --c: #33b9ff; --ink: #121326; --mut: #6c6f84; --line: rgba(18,19,38,.1);
  --stage: linear-gradient(160deg, #eef0ff 0%, #fbe9f6 55%, #ffd6ec 100%);
  position: fixed; inset: 0; z-index: 1200;
  display: flex; align-items: center; justify-content: center;
  padding: 32px 24px;
  background: rgba(13,13,36,.5);
  -webkit-backdrop-filter: blur(4px); backdrop-filter: blur(4px);
  opacity: 0; visibility: hidden;
  transition: opacity .3s ease, visibility .3s ease;
  font-family: "Poppins", Arial, sans-serif;
}
.tvqv.is-open { opacity: 1; visibility: visible; }
.tvqv * { box-sizing: border-box; }
.tvqv__panel {
  position: relative; display: flex; flex-direction: column;
  width: min(1040px, 100%);
  max-height: min(780px, calc(100vh - 64px)); max-height: min(780px, calc(100dvh - 64px));
  overflow: hidden; border-radius: 22px; background: #fff; color: var(--ink);
  box-shadow: 0 40px 100px rgba(13,13,36,.35);
  transform: translateY(16px) scale(.98);
  transition: transform .4s cubic-bezier(.2,.8,.2,1);
  outline: none;
}
.tvqv.is-open .tvqv__panel { transform: none; }
.tvqv__panel::before {
  content: ""; position: absolute; top: 0; left: 8%; right: 8%; z-index: 6; height: 2px; border-radius: 2px;
  background: linear-gradient(90deg, transparent, var(--c) 18%, var(--v) 50%, var(--p) 82%, transparent);
  box-shadow: 0 0 10px rgba(255,45,143,.45);
}
.tvqv__close {
  position: absolute; top: 16px; right: 16px; z-index: 7;
  display: grid; place-items: center; width: 42px; height: 42px; padding: 0;
  border: 1px solid var(--line); border-radius: 50%; background: #fff; color: var(--ink);
  box-shadow: 0 4px 12px rgba(18,19,38,.08); cursor: pointer;
  transition: border-color .2s ease, color .2s ease, transform .3s cubic-bezier(.2,.8,.2,1);
}
.tvqv__close svg { width: 14px; height: 14px; }
.tvqv__close:hover { border-color: var(--p); color: var(--p); transform: rotate(90deg); }
.tvqv__scroll { overflow-y: auto; overscroll-behavior: contain; }

.tvqv__loading { display: grid; place-items: center; min-height: 360px; }
.tvqv__spin { width: 38px; height: 38px; border: 3px solid rgba(255,45,143,.18); border-top-color: var(--p); border-radius: 50%; animation: tvqv-spin .7s linear infinite; }
@keyframes tvqv-spin { to { transform: rotate(360deg); } }
.tvqv__fail { display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 80px 24px; text-align: center; color: var(--mut); }

.qv { display: grid; grid-template-columns: minmax(0,1fr) minmax(0,1fr); gap: 40px; padding: 36px 40px 36px 36px; }
.qv-media { min-width: 0; }
.qv-stage { position: relative; display: block; aspect-ratio: 1/1; overflow: hidden; border-radius: 18px; background: var(--stage); }
.qv-img { position: absolute; inset: 6%; width: 88%; height: 88%; object-fit: contain; mix-blend-mode: multiply; transition: opacity .25s ease, transform .6s cubic-bezier(.2,.8,.2,1); }
.qv-img.is-swapping { opacity: .3; }
.qv-stage:hover .qv-img { transform: scale(1.04); }
.qv-thumbs { display: flex; gap: 10px; margin-top: 12px; padding: 3px; overflow-x: auto; scrollbar-width: none; }
.qv-thumbs::-webkit-scrollbar { display: none; }
.qv-thumb { flex: 0 0 64px; height: 64px; padding: 4px; border: 0; border-radius: 12px; background: var(--stage); box-shadow: inset 0 0 0 1px var(--line); cursor: pointer; transition: box-shadow .2s ease, transform .2s ease; }
.qv-thumb img { width: 100%; height: 100%; object-fit: contain; mix-blend-mode: multiply; }
.qv-thumb:hover { transform: translateY(-2px); }
.qv-thumb.is-active { box-shadow: 0 0 0 2px var(--p), 0 4px 12px rgba(255,45,143,.25); }

.qv-info { display: flex; flex-direction: column; min-width: 0; padding-top: 6px; padding-right: 24px; }
.qv-vendor { margin: 0 0 8px; color: var(--p); font-size: 11px; font-weight: 700; letter-spacing: .22em; text-transform: uppercase; }
.qv-title { margin: 0 0 14px; font-family: "Poppins", Arial, sans-serif; font-size: clamp(22px, 2vw, 28px); font-weight: 700; line-height: 1.2; letter-spacing: -.01em; }
.qv-title a { color: var(--ink); text-decoration: none; transition: color .2s ease; }
.qv-title a:hover { color: var(--p); }
.qv-price { display: flex; flex-wrap: wrap; align-items: baseline; gap: 6px 12px; padding-bottom: 20px; margin-bottom: 20px; border-bottom: 1px solid var(--line); }
.qv-now { color: var(--p); font-size: 26px; font-weight: 800; letter-spacing: -.01em; }
.qv-was { color: var(--mut); font-size: 16px; }
.qv-save { align-self: center; padding: 4px 9px; border-radius: 8px; background: rgba(255,45,143,.1); color: #c4126d; font-size: 12px; font-weight: 700; letter-spacing: .04em; }

.qv-opt { margin: 0 0 18px; padding: 0; border: 0; min-width: 0; }
.qv-legend { margin: 0 0 10px; padding: 0; color: var(--mut); font-size: 12px; font-weight: 600; letter-spacing: .12em; text-transform: uppercase; }
.qv-legend b { color: var(--ink); font-weight: 700; letter-spacing: .02em; text-transform: none; }
.qv-values { display: flex; flex-wrap: wrap; gap: 8px; }
.qv-value { display: inline-flex; align-items: center; gap: 8px; min-height: 42px; padding: 0 16px; border: 1.5px solid var(--line); border-radius: 12px; background: #fff; color: var(--ink); font: inherit; font-size: 14px; font-weight: 600; cursor: pointer; transition: border-color .2s ease, background .2s ease, box-shadow .2s ease; }
.qv-value:hover { border-color: var(--p); }
.qv-value[aria-pressed="true"] { border-color: var(--p); background: rgba(255,45,143,.06); box-shadow: 0 0 0 3px rgba(255,45,143,.12); }
.qv-value.is-out { border-style: dashed; background: #f7f7fa; color: #9a9cad; }
.qv-value.is-out .qv-vtext { text-decoration: line-through; }
.qv-swatch { position: relative; overflow: hidden; flex: 0 0 auto; width: 16px; height: 16px; border-radius: 50%; background: #cfcbd6; box-shadow: inset 0 0 0 1px rgba(0,0,0,.12); } .qv-swatch::after { content: ''; position: absolute; inset: 0; border-radius: 50%; background: radial-gradient(circle at 35% 30%, rgba(255,255,255,.7), rgba(255,255,255,0) 45%); }

.qv-buy { display: grid; grid-template-columns: 132px minmax(0,1fr); gap: 10px; margin-top: 6px; }
.qv-qty { display: flex; align-items: center; height: 54px; border: 1.5px solid rgba(18,19,38,.16); border-radius: 12px; background: #fff; overflow: hidden; }
.qv-qty button { display: grid; place-items: center; width: 42px; height: 100%; padding: 0; border: 0; background: none; color: var(--ink); cursor: pointer; transition: background .2s ease, color .2s ease; }
.qv-qty button:hover { background: rgba(255,45,143,.07); color: var(--p); }
.qv-qty svg { width: 14px; height: 14px; }
.qv-qty span { flex: 1; text-align: center; font-size: 16px; font-weight: 700; font-variant-numeric: tabular-nums; }
.qv-add { display: flex; align-items: center; justify-content: center; gap: 10px; height: 54px; padding: 0 20px; border: 0; border-radius: 12px; background: linear-gradient(90deg, #ff5aa5 0%, #ff1f8e 55%, #f0129c 100%); color: #fff; font: inherit; font-size: 15px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; white-space: nowrap; cursor: pointer; box-shadow: 0 10px 26px rgba(255,31,142,.35), inset 0 1px 0 rgba(255,255,255,.3); transition: transform .25s ease, box-shadow .25s ease, filter .25s ease; }
.qv-add svg { width: 20px; height: 20px; }
.qv-add:hover:not(:disabled) { transform: translateY(-2px); filter: brightness(1.05); box-shadow: 0 14px 32px rgba(255,31,142,.45), 0 0 22px rgba(168,85,247,.2); }
.qv-add:disabled { background: #ececf2; color: #9a9cad; box-shadow: none; cursor: not-allowed; }
.qv-now-btn { width: 100%; height: 50px; margin-top: 10px; border: 1.5px solid var(--ink); border-radius: 12px; background: #fff; color: var(--ink); font: inherit; font-size: 14px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; cursor: pointer; transition: background .2s ease, color .2s ease; }
.qv-now-btn:hover:not(:disabled) { background: var(--ink); color: #fff; }
.qv-now-btn[hidden] { display: none; }
.qv-add.is-loading, .qv-now-btn.is-loading { pointer-events: none; opacity: .7; }

.qv-error { margin: 12px 0 0; color: #d40f3c; font-size: 13px; line-height: 1.4; }
.qv-error[hidden] { display: none; }
.qv-trust { display: flex; flex-wrap: wrap; gap: 8px 20px; margin: 18px 0 0; padding: 16px 0 0; border-top: 1px solid var(--line); list-style: none; }
.qv-trust li { display: flex; align-items: center; gap: 8px; color: var(--mut); font-size: 13px; }
.qv-trust svg { width: 18px; height: 18px; color: var(--p); }
.qv-details { position: relative; align-self: flex-start; margin-top: 16px; padding-bottom: 4px; color: var(--ink); font-size: 12.5px; font-weight: 700; letter-spacing: .14em; text-decoration: none; text-transform: uppercase; }
.qv-details::after { content: ""; position: absolute; left: 0; right: 0; bottom: 0; height: 2px; border-radius: 2px; background: linear-gradient(90deg, var(--p), var(--v) 60%, var(--c)); }
.qv-details:hover { color: var(--p); }
.tvqv button:focus-visible, .tvqv a:focus-visible { outline: 3px solid #0d0d24; outline-offset: 2px; }

@media (max-width: 989px) {
  .qv { gap: 28px; padding: 30px 28px 28px; }
  .qv-info { padding-right: 0; }
}
@media (max-width: 749px) {
  .tvqv { align-items: flex-end; padding: 0; }
  .tvqv__panel { width: 100%; max-height: 92vh; max-height: 92dvh; border-radius: 22px 22px 0 0; transform: translateY(30px); }
  .qv { grid-template-columns: minmax(0,1fr); gap: 18px; padding: 22px 16px calc(20px + env(safe-area-inset-bottom)); }
  .qv-stage { aspect-ratio: 4/3; border-radius: 16px; }
  .qv-thumb { flex-basis: 56px; height: 56px; }
  .qv-title { margin-bottom: 10px; padding-right: 44px; font-size: 20px; }
  .qv-now { font-size: 22px; }
  .qv-price { padding-bottom: 16px; margin-bottom: 16px; }
  .qv-buy { grid-template-columns: 112px minmax(0,1fr); }
  .qv-add { font-size: 14px; }
  .qv-trust li { font-size: 12px; }
  .tvqv__close { top: 12px; right: 12px; width: 38px; height: 38px; }
}
@media (prefers-reduced-motion: reduce) {
  .tvqv, .tvqv__panel, .tvqv * { transition: none !important; }
}`;

  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 12h12"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="m3 7.5 9 4.5 9-4.5M12 12v9"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>'
  };

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    var s = src.indexOf('//') === 0 ? 'https:' + src : src;
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function imgKey(src) { return String(src || '').split('?')[0].replace(/^https?:/, ''); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  }
  function swatch(optionName, value) {
    if (!/colou?r/i.test(optionName)) return '';
    /* shared resolver (assets/kg-color.js) — same circle as the cart */
    if (window.KGColor) return KGColor.html(value, 'qv-swatch');
    if (!window.CSS || !CSS.supports) return '';
    var raw = String(value).toLowerCase();
    var parts = [raw.replace(/[^a-z]/g, '')].concat(
      raw.split(/\s*(?:\/|,|&|\band\b|-)\s*/).reverse().map(function (p) { return p.replace(/[^a-z]/g, ''); })
    );
    var css = '';
    for (var i = 0; i < parts.length; i++) {
      if (parts[i] && CSS.supports('color', parts[i])) { css = parts[i]; break; }
    }
    return '<span class="qv-swatch" style="background-color:' + (css || '#cfcbd6') + '" aria-hidden="true"></span>';
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function cleanPath(url) { return String(url || '').split('?')[0].replace(/\/$/, ''); }

  /* each product is only downloaded once */
  var cache = {};
  function getProduct(path) {
    if (!cache[path]) {
      cache[path] = fetch(path + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      cache[path].catch(function () { delete cache[path]; });
    }
    return cache[path];
  }

  /* shared add-to-cart request (refreshes the TV cart drawer) */
  function cartAdd(id, qty, withSections) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', qty || 1);
    if (withSections && cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    return fetch((window.routes && window.routes.cart_add_url) || root() + 'cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || kgT('could_not_add', 'Could not add to cart'));
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tv-quick-view', productVariantId: id, cartData: res }); } catch (e) {}
        }
        return { res: res, cart: cart };
      });
  }
  function showInCart(out, activeEl) {
    var cart = out.cart, res = out.res;
    if (cart && typeof cart.renderContents === 'function' && res.sections) {
      if (activeEl && typeof cart.setActiveElement === 'function') cart.setActiveElement(activeEl);
      cart.classList.remove('is-empty');
      cart.renderContents(res);
      return true;
    }
    window.location.href = (window.routes && window.routes.cart_url) || root() + 'cart';
    return false;
  }

  /* ---------- popup shell ---------- */
  var el, panel, box, S = null, reqId = 0, lastFocus = null, opener = null;

  function build() {
    if (el) return;
    if (!document.getElementById('tvqv-css')) {
      var st = document.createElement('style');
      st.id = 'tvqv-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    el = document.createElement('div');
    el.className = 'tvqv';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="tvqv__panel" role="dialog" aria-modal="true" aria-label="' + kgT('quick_view', 'Quick view') + '" tabindex="-1">' +
        '<button type="button" class="tvqv__close" aria-label="' + kgT('close', 'Close') + '">' + ICON.x + '</button>' +
        '<div class="tvqv__scroll" data-qv-box></div>' +
      '</div>';
    document.body.appendChild(el);
    panel = el.querySelector('.tvqv__panel');
    box = el.querySelector('[data-qv-box]');
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    el.querySelector('.tvqv__close').addEventListener('click', close);
    box.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
  }

  function open(url, from) {
    build();
    opener = from || null;
    lastFocus = document.activeElement;
    var id = ++reqId;

    box.innerHTML = '<div class="tvqv__loading"><span class="tvqv__spin" aria-label="' + kgT('loading', 'Loading') + '"></span></div>';
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tvqv-lock');
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 30);

    var path = cleanPath(url);
    var vid = new URLSearchParams(String(url).split('?')[1] || '').get('variant');

    getProduct(path)
      .then(function (p) { if (id === reqId) render(p, path, vid); })
      .catch(function (err) {
        if (id !== reqId) return;
        console.warn('Quick view: product could not load', err);
        box.innerHTML =
          '<div class="tvqv__fail"><p>' + kgT('load_error', 'Sorry, this product couldn’t be loaded here.') + '</p>' +
          '<a class="qv-details" href="' + esc(path) + '">View product page →</a></div>';
      });
  }

  function close() {
    if (!el || !el.classList.contains('is-open')) return;
    reqId++;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tvqv-lock');
    setTimeout(function () { if (!el.classList.contains('is-open')) box.innerHTML = ''; }, 350);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function onKey(e) {
    if (!el || !el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- product ---------- */
  function render(p, url, variantId) {
    var variants = p.variants || [];
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var opts = names.map(function (name, i) {
      var values = [];
      variants.forEach(function (v) {
        var x = v.options && v.options[i];
        if (x != null && values.indexOf(x) < 0) values.push(x);
      });
      return { name: name, values: values };
    });
    var start =
      variants.find(function (v) { return String(v.id) === String(variantId); }) ||
      variants.find(function (v) { return v.available; }) ||
      variants[0];

    S = {
      p: p,
      url: url,
      qty: 1,
      variants: variants,
      opts: opts,
      /* one variant = nothing to choose, so no option buttons at all */
      hideOpts: variants.length <= 1,
      sel: start && start.options ? start.options.slice() : [],
      images: (p.images || []).map(function (x) { return typeof x === 'string' ? x : x && x.src; }).filter(Boolean).slice(0, 8)
    };

    var first = (start && start.featured_image && start.featured_image.src) || S.images[0] || p.featured_image || '';
    var thumbs = '';
    if (S.images.length > 1) {
      thumbs = '<div class="qv-thumbs">' + S.images.map(function (src, i) {
        return '<button type="button" class="qv-thumb" data-qv-thumb="' + esc(src) + '" aria-label="' + kgT('show_picture', 'Show picture {n}', { n: i + 1 }) + '">' +
          '<img src="' + esc(imgUrl(src, 160)) + '" alt="" loading="lazy" width="80" height="80"></button>';
      }).join('') + '</div>';
    }
    var trust = TRUST.filter(Boolean).map(function (t, i) {
      return '<li>' + (i === 0 ? ICON.box : ICON.truck) + '<span>' + esc(t) + '</span></li>';
    }).join('');

    box.innerHTML =
      '<div class="qv">' +
        '<div class="qv-media">' +
          '<a class="qv-stage" href="' + esc(url) + '" tabindex="-1">' +
            (first ? '<img class="qv-img" data-qv-main src="' + esc(imgUrl(first, 900)) + '" alt="' + esc(p.title) + '" width="900" height="900">' : '') +
          '</a>' + thumbs +
        '</div>' +
        '<div class="qv-info">' +
          (p.vendor ? '<p class="qv-vendor">' + esc(p.vendor) + '</p>' : '') +
          '<h2 class="qv-title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h2>' +
          '<div class="qv-price" data-qv-price></div>' +
          '<div data-qv-options></div>' +
          '<div class="qv-buy">' +
            '<div class="qv-qty">' +
              '<button type="button" data-qv-minus aria-label="' + kgT('decrease', 'Decrease quantity') + '">' + ICON.minus + '</button>' +
              '<span data-qv-qty aria-live="polite">1</span>' +
              '<button type="button" data-qv-plus aria-label="' + kgT('increase', 'Increase quantity') + '">' + ICON.plus + '</button>' +
            '</div>' +
            '<button type="button" class="qv-add" data-qv-add>' + ICON.bag + '<span data-qv-add-label>' + kgT('add_to_cart', 'Add to cart') + '</span></button>' +
          '</div>' +
          '<button type="button" class="qv-now-btn" data-qv-buy>' + kgT('buy_now', 'Buy it now') + '</button>' +
          '<p class="qv-error" data-qv-error role="alert" hidden></p>' +
          (trust ? '<ul class="qv-trust">' + trust + '</ul>' : '') +
          '<a class="qv-details" href="' + esc(url) + '">' + kgT('view_details', 'View full details') + ' <span aria-hidden="true">→</span></a>' +
        '</div>' +
      '</div>';

    update();
  }

  function matches(v, i, value) {
    for (var j = 0; j < S.sel.length; j++) {
      if (v.options[j] !== (j === i ? value : S.sel[j])) return false;
    }
    return true;
  }
  function current() { return S.variants.find(function (v) { return matches(v, -1); }) || null; }
  function stateOf(i, value) {
    var hits = S.variants.filter(function (v) { return matches(v, i, value); });
    if (!hits.length) return 'none';
    return hits.some(function (v) { return v.available; }) ? 'ok' : 'soldout';
  }
  function choose(i, value) {
    S.sel[i] = value;
    if (!current()) {
      var withValue = S.variants.filter(function (v) { return v.options[i] === value; });
      var pick = withValue.find(function (v) { return v.available; }) || withValue[0];
      if (pick) S.sel = pick.options.slice();
    }
    update();
  }

  function update() {
    var v = current() || (S.variants.length === 1 ? S.variants[0] : null);

    var html = '';
    if (!S.hideOpts) {
      S.opts.forEach(function (o, i) {
        if (o.values.length <= 1) return; /* only show options with a real choice */
        html += '<fieldset class="qv-opt"><legend class="qv-legend">' + esc(o.name) + ': <b>' + esc(S.sel[i]) + '</b></legend><div class="qv-values">';
        o.values.forEach(function (val) {
          var st = stateOf(i, val);
          html += '<button type="button" class="qv-value' + (st !== 'ok' ? ' is-out' : '') + '" data-qv-opt="' + i + '" data-value="' + esc(val) + '" aria-pressed="' + (S.sel[i] === val) + '">' +
            swatch(o.name, val) + '<span class="qv-vtext">' + esc(val) + '</span>' +
          '</button>';
        });
        html += '</div></fieldset>';
      });
    }
    box.querySelector('[data-qv-options]').innerHTML = html;

    var pv = v || S.variants[0] || { price: 0 };
    var price = '<span class="qv-now">' + money(pv.price) + '</span>';
    /* shared sale rule (assets/kg-sale.js): threshold, floored %, Rule-of-100 badge */
    var si = window.KGSale ? KGSale.info(pv.price, pv.compare_at_price, money) : { on: false };
    if (si.on) {
      price += '<s class="qv-was">' + money(pv.compare_at_price) + '</s>' +
        '<span class="qv-save">' + esc(si.badge) + '</span>';
    }
    box.querySelector('[data-qv-price]').innerHTML = price;

    var ok = !!(v && v.available);
    var add = box.querySelector('[data-qv-add]');
    var buy = box.querySelector('[data-qv-buy]');
    add.disabled = !ok;
    buy.disabled = !ok;
    buy.hidden = !ok;
    box.querySelector('[data-qv-add-label]').textContent = !v ? kgT('unavailable', 'Unavailable') : v.available ? kgT('add_to_cart', 'Add to cart') : kgT('out_of_stock', 'Out of stock');
    box.querySelector('[data-qv-qty]').textContent = S.qty;
    err('');

    if (v && v.featured_image && v.featured_image.src) setMain(v.featured_image.src);
    else {
      var m = box.querySelector('[data-qv-main]');
      markThumb(m ? m.getAttribute('src') : '');
    }
  }

  function setMain(src) {
    var main = box.querySelector('[data-qv-main]');
    if (!main || !src) return;
    var next = imgUrl(src, 900);
    if (imgKey(main.getAttribute('src')) !== imgKey(next)) {
      main.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () { main.src = next; main.classList.remove('is-swapping'); };
      pre.src = next;
    }
    markThumb(src);
  }
  function markThumb(src) {
    var k = imgKey(src);
    box.querySelectorAll('[data-qv-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', imgKey(t.getAttribute('data-qv-thumb')) === k);
    });
  }
  function err(msg) {
    var e = box.querySelector('[data-qv-error]');
    if (!e) return;
    e.textContent = msg || '';
    e.hidden = !msg;
  }

  function onClick(e) {
    var t;
    if ((t = e.target.closest('[data-qv-thumb]'))) return setMain(t.getAttribute('data-qv-thumb'));
    if ((t = e.target.closest('[data-qv-opt]'))) return choose(Number(t.getAttribute('data-qv-opt')), t.getAttribute('data-value'));
    if (e.target.closest('[data-qv-minus]')) { S.qty = Math.max(1, S.qty - 1); box.querySelector('[data-qv-qty]').textContent = S.qty; return; }
    if (e.target.closest('[data-qv-plus]')) { S.qty = Math.min(99, S.qty + 1); box.querySelector('[data-qv-qty]').textContent = S.qty; return; }
    if (e.target.closest('[data-qv-add]')) return popupAdd(false);
    if (e.target.closest('[data-qv-buy]')) return popupAdd(true);
  }

  function popupAdd(buyNow) {
    var v = current() || (S.variants.length === 1 ? S.variants[0] : null);
    if (!v || !v.available) return;
    var btn = box.querySelector(buyNow ? '[data-qv-buy]' : '[data-qv-add]');
    btn.classList.add('is-loading');
    err('');
    cartAdd(v.id, S.qty, !buyNow)
      .then(function (out) {
        if (buyNow) { window.location.href = root() + 'checkout'; return; }
        var activeEl = opener;
        close();
        setTimeout(function () { showInCart(out, activeEl); }, 150);
      })
      .catch(function (e) { err(e && e.message ? e.message : kgT('went_wrong', 'Something went wrong. Please try again.')); })
      .finally(function () { if (btn && btn.isConnected) btn.classList.remove('is-loading'); });
  }

  /* (The old fixButtons() pass is gone: featured-collection decides single vs multi
     variant server-side and the recently-viewed cards decide it from product JSON,
     so it only produced one extra /products/<handle>.js request per card.) */

  function cardAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('span');
    btn.classList.add('is-busy', 'is-loading');
    if (label) label.textContent = kgT('adding', 'Adding…');
    cartAdd(btn.getAttribute('data-tv-add'), 1, true)
      .then(function (out) {
        if (label) label.textContent = kgT('add_to_cart', 'Add to cart');
        showInCart(out, btn);
      })
      .catch(function () {
        if (label) label.textContent = kgT('try_again', 'Try again');
        setTimeout(function () { if (label) label.textContent = kgT('add_to_cart', 'Add to cart'); }, 1800);
      })
      .finally(function () { btn.classList.remove('is-busy', 'is-loading'); });
  }

  /* ---------- catch clicks before the sections' own handlers ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var addBtn = e.target.closest('[data-tv-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      cardAdd(addBtn);
      return;
    }

    var t = e.target.closest(TRIGGERS);
    if (!t) return;
    var url = t.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    open(url, t);
  }, true);

  window.TVQuickView = { open: open, close: close, getProduct: getProduct };
})();